import { render, staticRenderFns } from "./FileType.vue?vue&type=template&id=9828bff4&"
import script from "./FileType.vue?vue&type=script&lang=js&"
export * from "./FileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9828bff4')) {
      api.createRecord('9828bff4', component.options)
    } else {
      api.reload('9828bff4', component.options)
    }
    module.hot.accept("./FileType.vue?vue&type=template&id=9828bff4&", function () {
      api.rerender('9828bff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileType.vue"
export default component.exports